import ResponseAttribution from "./ResponseAttribution";
import ResponseText from "./ResponseText";
import ButtonTextLink from "../../../../DesignSystem/Buttons/ButtonTextLink";
import { useEffect, useState } from "react";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../../../../../backend/firebaseConfig";
import dayjs from "dayjs";
import "../../../../../css/Compliance/Chatbot/CachedResponses.css";
import "../../../../../css/Compliance/Chatbot/ChatbotScreen.css";
import { useUserPermissions } from "../../../../SignIn/UserPermissionsContext";
import { useUserEmail } from "../../../../SignIn/UserEmailContext";
import Popup from "../../../../DesignSystem/Popups/Popup";
import NewTextArea from "../../../../DesignSystem/Inputs/NewTextArea";

const PendingApprovals = ({ searchTerm = "" }) => {
  const [responses, setResponses] = useState([]);
  const { userPermissions } = useUserPermissions();
  const isAdmin = userPermissions.includes("Administrator");
  const COMPLIANCE_CHATBOT_URL = process.env.REACT_APP_COMPLIANCE_CHATBOT_URL;
  const { userEmail } = useUserEmail();
  const [showSuggestionModal, setShowSuggestionModal] = useState(false);
  const [suggestedAnswer, setSuggestedAnswer] = useState("");
  const [currentRejectMsg, setCurrentRejectMsg] = useState(null);

  const fetchResponses = async () => {
    const snapshot = await getDocs(
      collection(db, "Compliance", "Cached Responses", "Pending Review")
    );
    const data = snapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));

    const sorted = data.sort((a, b) => {
      const dateA = new Date(a.timestamp);
      const dateB = new Date(b.timestamp);
      return dateB - dateA;
    });

    setResponses(sorted);
  };
  useEffect(() => {
    fetchResponses();
    // console.log("User Email:", userEmail);
  }, []);

  const handleApprove = async (question, answer, requestedBy) => {
    // const messageToApprove = messages.find(
    //   (msg) => msg.text === answer && msg.sender === "bot"
    // );

    // const requestedBy = messageToApprove?.requestedBy || "unknown";

    await fetch(`${COMPLIANCE_CHATBOT_URL}/api/approve`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        question,
        answer,
        requestedBy, // preserved from when user submitted the question
        approvedBy: userEmail || localStorage.getItem("userEmail"), // current admin approver
      }),
    });

    // Optional: Update UI
    // setMessages((prev) =>
    //   prev.map((msg) =>
    //     msg.text === answer ? { ...msg, firebasePending: false } : msg
    //   )
    // );
    // Optionally, you can also remove the approved response from the UI
    fetchResponses();
  };

  const handleReject = async (
    question,
    answer,
    suggestedAnswer,
    requestedBy
  ) => {
    // console.log(
    //   "Rejecting response:",
    //   question,
    //   answer,
    //   suggestedAnswer,
    //   requestedBy
    // );
    await fetch(`${COMPLIANCE_CHATBOT_URL}/api/reject`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        question,
        answer,
        requestedBy,
        rejectedBy: userEmail || localStorage.getItem("userEmail"), // current admin rejecting
        suggestedAnswer: suggestedAnswer.trim() || "No suggestion provided",
      }),
    });

    fetchResponses();
  };

  // useEffect(() => {
  // console.log(localStorage.getItem("userEmail"));
  //   console.log(userEmail);
  // }, []);

  return (
    <div className="chatbot-responses table-scroll-container">
      <table className="website-table ain-history-table"><thead>
      <tr >
        <th className="FP_Help_Text_Semibold table-index-column"></th>
        <th className="FP_Help_Text_Semibold">PROMPT</th>
        <th className="FP_Help_Text_Semibold">RESPONSE</th>
      </tr></thead><tbody>
      {responses
        .filter(({ requestedBy }) => isAdmin || requestedBy === userEmail)
        .filter(({ question, answer, requestedBy }) =>
          [question, answer, requestedBy].some((value) =>
            String(value ?? "").toLowerCase().includes(searchTerm.trim().toLowerCase())
          )
        )
        .map(({ id, question, answer, timestamp, requestedBy }, index) => (
          <tr  key={id}>
            <td className="FP_Content table-index-column">
              {index + 1}.
            </td>

            <td className="FP_Content">
              <div className="Content">{question}</div>
              {isAdmin && (
                <ResponseAttribution label="Requested by" value={requestedBy} />
              )}
              {isAdmin && (
                <div className="Content-Small">
                  {dayjs(timestamp).format("DD/MM/YYYY")}
                </div>
              )}
              <div className="ain-history-prompt-actions">
                <ButtonTextLink
              onClick={() => handleApprove(question, answer, requestedBy)}

            >
              Approve
                </ButtonTextLink>
                <ButtonTextLink
              onClick={() => {
                setCurrentRejectMsg({ question, answer, requestedBy });
                setShowSuggestionModal(true);
                setSuggestedAnswer("");
              }}

            >
              Reject
                </ButtonTextLink>
              </div>
            </td>
            <td className="FP_Content"><ResponseText answer={answer} /></td>
          </tr>
        ))}</tbody></table>
      {showSuggestionModal && currentRejectMsg && (
        <Popup
          open={showSuggestionModal}
          className="ain-history-reject-modal"
          title={currentRejectMsg.question}
          titleClassName="FP_Content_Semibold"
          confirmLabel="Submit"
          onCancel={() => {
            setShowSuggestionModal(false);
            setCurrentRejectMsg(null);
          }}
          onConfirm={async () => {
            const { question, answer, requestedBy } = currentRejectMsg;
            await handleReject(question, answer, suggestedAnswer, requestedBy);
            setSuggestedAnswer("");
            setCurrentRejectMsg(null);
            setShowSuggestionModal(false);
          }}
        >
          <NewTextArea
            id="reject-suggested-response"
            placeholder="Suggested Response..."
            value={suggestedAnswer}
            onChange={(e) => setSuggestedAnswer(e.target.value)}
          />
        </Popup>
      )}
    </div>
  );
};

export default PendingApprovals;
